<template>
	<div class="full-height" :class="$skin.name">
		<Loading
			v-if="is_loading"
		></Loading>
		<div
			v-if="is_ready"
			class="full-height"
		>
			<Side
				v-if="is_side"
				:user="user"
				:shop_info="shop_info"
				:category="category"

				@toggleSide="toggleSide"
				@push="toLocation"
			>
			</Side>
			<div class="full-height">
				<Top
					v-if="!program.not_top"
					:program="program"
					:user="user"
					:shop_info="shop_info"

					@toggleSide="toggleSide"
					@push="toLocation"
				></Top>

				<hr v-if="program.top_line" class="under-line mb-50-pc mb-20-m"/>

				<Title
					v-if="program.title"
					:program="program"
					:cart_cnt="cart_cnt"

					@push="toLocation"
				></Title>

				<SubTop
					v-if="user.is_confirm == '1' && is_sub_top"
					:user="user"
					:codes="codes"
					:shop_info="shop_info"
				></SubTop>

				<router-view
					v-if="is_confirm"
					:cart_info="cart_items"
					:user="user"
					:shop_info="shop_info"
					:key="$route.fullPath"
					:codes="codes"
					:category="category"

					@getCartList="getCartList"
					@onLoad="setProgram"
					:class="{ 'full-height' : program.is_full, 'container': !program.is_container}"
				></router-view>

				<PopupConfirm
					v-else
					@click="toConfirm"
					:not_cancel="true"
				>
					<template
						v-slot:title
					>계정 보안</template>
					<template
						v-slot:main-txt
					>계정 보안을 위해 본인 인증 및 비밀번호 변경 후 이용하세요</template>
				</PopupConfirm>

				<SubBottom
					v-if="user.is_confirm == '1' && is_sub_bottom"
					:user="user"
				></SubBottom>

				<Bottom
					v-if="program.bottom"

					:user="user"
					:shop_info="shop_info"
					:cart_cnt="cart_cnt"
					@push="toLocation"
					@toggleSide="toggleSide"
				></Bottom>
			</div>
		</div>

		<Popup v-if="false"></Popup>

		<Notify
			:msg="notifyCondition.message"
			:type="notifyCondition.type"

			@clearMsg="clearMsg"
		/>

		<PersonalConfirm
			:user="user"
		></PersonalConfirm>

		<PopupConfirm
			v-if="is_on_grade"

			:not_cancel="true"
			@click="postGradeConfirm"
			@cancel="postGradeConfirm"
		>

			<template
				v-slot:title
			>회원 등급 변경 안내</template>
			<template
				v-slot:main-txt
			> [{{ last_grade.code_name }}] 회원 등급이 변경 되었습니다. </template>

		</PopupConfirm>
	</div>
</template>

<script>

	import Notify from '@/components/AlertMsg'
	import Side from "@/view/Layout/Side";
	import Top from "@/view/Layout/Top";
	import Bottom from "@/view/Layout/Bottom";
	import Title from "@/view/Layout/Title";
	import Loading from "@/view/Layout/Loading";
	import SubTop from "@/view/Layout/SubTop";
	import SubBottom from "./SubBottom";
	import Popup from "@/view/Layout/Popup";
	import PersonalConfirm from "./PersonalConfirm";
	import PopupConfirm from "./PopupConfirm";
	
	export default{
		name: 'Layout'
		,props: ['user', 'shop_info', 'codes', 'category_list']
		,components: {
			PopupConfirm, PersonalConfirm, Popup, SubBottom, SubTop, Loading, Title, Bottom, Side, Top, Notify }
		,data: function(){
			return {
				program: {
				}
				,notifyCondition: {
					message: '메시지 입니다'
					,type: ''
				}
				,is_side: false
				,cart_items: [

				]
				,is_loading: true
				,is_ready: false
				,category: null
				, is_on_grade: false
				, item_nice: {}
			}
		}
		,computed:{
			cart_cnt: function(){
				return this.cart_items.length
			}
			, is_sub_top: function(){
				let t = false
				if(this.$route.path.indexOf('Account') > -1){
					t = true
				}
				return t
			}
			, is_sub_bottom: function(){
				let t = false
				if(this.$route.path.indexOf('Account') > -1){
					t = true
				}
				return t
			}
			, last_grade: function(){
				let t = ''

				if(this.is_on_grade){
					this.codes.M001.items.filter( (grade) => {
						if(grade.code_index == this.user.member_level ) {
							t = grade
						}
					})
				}

				return t
			}
			, is_confirm: function(){
				let t = false

				if(!this.user.member_id || (this.user.member_id && this.user.is_confirm == '1') || (this.user.member_id && this.$route.name == 'MyPage') || (this.user.member_id && this.$route.name == 'Password')){
					t = true
				}

				return t
			}

	}
		,methods: {

			getData: async function(){
				try{
					const result = await this.$request.init({
						method: 'get'
						,url: '/product/getCategory'
					})
					if(result.success){
						this.category = result.data
					}else{
						this.$bus.$emit('notify', { type: 'error', message: result.message})
					}
				}catch (e) {
					console.log(e)
				}finally {
					this.is_loading = false
					this.is_ready = true
				}
			}
			,setNotify: function({type, message}){
				this.notifyCondition = {
					message: message
					,type: type
				}
			}
			,clearMsg: function(){
				this.notifyCondition.message = ''
			}
			,toggleSide: function(){
				this.is_side = !this.is_side
			}
			,setProgram: function(program){
				this.program = program
			}
			,toBack: function(){
				this.$router.back()
			}
			, toLocation: function( {name, params, query}){
				this.$router.push({ name: name, params: params, query: query}).catch(function(e){
					console.log(e)
				});
			}
			,onLoading: function(){
				this.is_loading = true
			}
			,offLoading: function(){
				setTimeout(() => {
					this.is_loading = false
				}, 300)
			}
			,getCartList: async function(){
				try{
					const result = await this.$request.init({
						method: 'get'
						,url: 'order/getCartList'
					})

					if(result.success){
						this.cart_items = result.data.content.result
					}else{
						this.$bus.$emit('notify', { type: 'error', message: result.message})
					}
				}catch (e) {
					console.log(e)
				}
			}
			, onGrade: function(){

				// console.log('this.user.last_grade', this.user.last_grade)
				this.is_on_grade = false
				if(this.user.last_grade){
					let history = JSON.parse(this.user.last_grade.history)
					if(history.grade != history.old && !history.confirm){
						this.is_on_grade = true
					}
				}
			}
			, postGradeConfirm: async function(){
				try{
					let history = this.user.last_grade
					let uid = history.uid
					const result = await this.$request.init({
						method: 'post'
						, url: 'main/postGradeConfirm'
						, data: {
							uid: uid
						}
					})

					if(!result.success){
						throw result.message
					}
				}catch (e) {
					console.log(e)
				}finally {
					this.$bus.$emit('setUser', [{key: 'last_grade', val: ''}])
					this.onGrade()
				}
			}
			, toConfirm: function(){
				this.$bus.$emit('to', { name: 'MyPage'})
			}

			, nice_request: async function(type){

				try {
					const result = await this.$request.init({
						method: 'post'
						,url: 'nice/request'
						,data: {
							type: type
						}
					})

					if(result.success){
						this.item_nice = result.data
						window.open(result.data.auth_url, 'nice', 'width=320px')
					}else{
						throw result.message
					}
				}catch (e){
					this.$bus.$emit('notify', { type: 'error', message: e})
				}
			}

			, niceResult: async function(){

				try {
					const result = await this.$request.init({
						method: 'post'
						,url: 'nice/postResult'
						,data: this.item_nice
					})

					if(result.success){
						window.open(result.data.open_url, 'nice', 'width=320px')
					}else{
						throw result.message
					}
				}catch (e){
					this.$bus.$emit('notify', { type: 'error', message: e})
				}
			}
			, niceResponse: function(e){
				try {
					let domains = process.env.VUE_APP_DOMAIN.split('|')
					let t = false
					for(let i = 0; i < domains.length; i++){
						if(e.origin.indexOf(domains[i]) > -1){
							t = true
						}
					}
					if(t){
						let data = e?.data
						if(data && typeof data == 'string'){
							data = JSON.parse(data)
							if(data.type == 'nice_response'){
								if(data.result){
									this.$set(this.item_nice, 'web_transaction_id', data.data.web_transaction_id)
									this.niceResult()
								}else{
									throw data.message
								}
							}
						}
					}
				}catch (e) {
					this.$bus.$emit('notify', { type: 'error', message: e})
				}
			}
		}
		, destroyed() {
			window.removeEventListener('message', this.niceResponse)
		}
		,created: function(){

			this.getData()

			this.$bus.$on('on', (type) =>{
				if(type){
					this.onLoading()
				}else{
					this.offLoading()
				}
			})

			this.$bus.$on('onLoad', (program) => {
				this.setProgram(program)
			})

			this.onGrade()


			this.$bus.$on('download', (type, folder, file) => {
				// console.log(type, folder, file)

				let location = window.location.hostname
				let base_url = ''
				if(location.indexOf('localhost') > -1){
					base_url = process.env.VUE_APP_DEV
				}else{
					base_url = '/shop_api'
				}
				window.open(base_url + '/global/download?type=' + type + '&folder=' + folder + '&file_name=' + file, "thumb")
			})

			this.$bus.$on('nice_request', ({type}) => {
				this.nice_request(type)
			})

			window.removeEventListener('message', this.niceResponse)
			setTimeout( () => {
				window.addEventListener('message', this.niceResponse)
			}, 100)
		}
		,watch: {
			$route(){
				this.is_side = false
				this.onGrade()
			}
		}
	}
	
</script>
<style>

@import "../../assets/css/reset.css";
@import "../../assets/css/template.css";
@import "../../assets/css/templateO.css";
@import "../../assets/css/templateB.css";
@import "../../assets/css/templateGift.css";
@import "../../assets/css/templateT.css";
@import "../../assets/css/base.css";
@import "../../assets/css/baseO.css";
@import "../../assets/css/baseB.css";
@import "../../assets/css/baseGift.css";
@import "../../assets/css/baseT.css";
</style>